export const position = () => {
  let domEl: any = null;
  let isDragElem: boolean = false;
  let offsetByClick: any = null;

  /** PUBLIC METHODS */

  const setDomElement = (modalId: string) => {
    domEl = document.getElementById(modalId);
    startWatchMouseMoveByBody(domEl);
  };

  const startDrag = (e: any) => {
    isDragElem = true;

    offsetByClick = {
      left: e.offsetX,
      top: e.offsetY,
    };
  };

  const getCenter = () => {
    const sizeParam = getSizeParams(domEl);
    return {
      left: `${
        sizeParam.screenSize.width / 2 - sizeParam.modalSize.width / 2
      }px`,
      top: `${
        sizeParam.screenSize.height / 2 - sizeParam.modalSize.height / 2
      }px`,
    };
  };

  const setPosition = (left?: string, top?: string) => {
    left ? domEl.style.setProperty('--position_left', left) : null;
    top ? domEl.style.setProperty('--position_top', top) : null;
  };

  const setPositionByResizeScreen = (screenWidth: number) => {
    const modalLeftBorderPosition = domEl.getBoundingClientRect().left;
    const modalRightBorderPosition =
      modalLeftBorderPosition + domEl.getBoundingClientRect().width;
    if (modalRightBorderPosition > screenWidth) {
      const leftPos = screenWidth - domEl.getBoundingClientRect().width;
      setPosition(`${leftPos > 0 ? leftPos : 0}px`);
    }
  };

  /** PRIVATE METHODS */

  // const getPosition = () => {
  //   return {
  //     left: domEl.style.getProperty('--position_left')
  //   }
  // }

  const getSizeParams = (el: any) => {
    return {
      screenSize: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      modalSize: {
        width: el.getBoundingClientRect().width,
        height: el.getBoundingClientRect().height,
      },
    };
  };

  const startWatchMouseMoveByBody = (domEl: any) => {
    if (domEl) {
      document.body.addEventListener('mousemove', (e: any) => {
        moveElement(e);
      });
      document.body.addEventListener('mouseup', (e: any) => {
        isDragElem = false;
      });
    }
  };

  const moveElement = (bodyEvt: any) => {
    if (isDragElem) {
      const sizeParam = getSizeParams(domEl);
      const mousePosition = {
        x: bodyEvt.clientX,
        y: bodyEvt.clientY,
      };

      const getMovePositionByLimit = () => {
        const modalLeftBorderPosition = mousePosition.x - offsetByClick.left;
        const modalTopBorderPosition = mousePosition.y - offsetByClick.top;
        const modalRightBorderPosition =
          modalLeftBorderPosition + sizeParam.modalSize.width;
        const modalBottomBorderPosition =
          modalTopBorderPosition + sizeParam.modalSize.height;
        const result = {
          left: modalLeftBorderPosition,
          top: modalTopBorderPosition,
        };

        if (modalRightBorderPosition > sizeParam.screenSize.width) {
          result.left =
            sizeParam.screenSize.width - sizeParam.modalSize.width - 15;
        }
        if (modalBottomBorderPosition > sizeParam.screenSize.height) {
          result.top =
            sizeParam.screenSize.height - sizeParam.modalSize.height - 15;
        }
        if (modalLeftBorderPosition <= 0) {
          result.left = 15;
        }
        if (modalTopBorderPosition <= 0) {
          result.top = 15;
        }
        return result;
      };

      const dragPosition = getMovePositionByLimit();
      setPosition(`${dragPosition.left}px`, `${dragPosition.top}px`);
    }
  };

  return {
    setDomElement,
    getCenter,
    setPosition,
    startDrag,
    setPositionByResizeScreen,
  };
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppModal/util/position.ts